const rsqlConfig = {
    extractFields: ['exactSearch'],
    textFields: ['title', 'showName', 'seriesTitle'],
    isShellAmsFranchise:
        '(amsFranchise.echostarId=notNull="true";(amsFranchise.roviProgramId=isNull="true",amsFranchise.roviProgramId=="0");amsFranchise.sourceId=isNull="true";amsEpisode=isNull="true";amsFranchise.tmsId=isNull="true")',
    isShellEpisode:
        '(amsEpisode.echostarId=notNull="true";(amsEpisode.roviProgramId=isNull="true",amsEpisode.roviProgramId=="0");amsEpisode.sourceId=isNull="true";amsEpisode.tmsId=isNull="true")',
    isShell: '(tmsId=isNull="true";sourceId=isNull="true";(roviProgramId=isNull="true",roviProgramId=="0"))',
    isNotShell: '(tmsId=notNull="true",sourceId=notNull="true",(roviProgramId=notNull="true";roviProgramId!="0"))',
    linkedRoviAndTmsIds: '(tmsId=notNull="true";roviProgramId=notNull="true";roviProgramId!=0)',
    linkedRovi: '(tmsId=isNull="true";sourceId=isNull="true";roviProgramId=notNull="true";roviProgramId!=0)',
    linkedTmsID: '(tmsId=notNull="true";sourceId=isNull="true";(roviProgramId=isNull="true",roviProgramId==0))',
    linkedSourceID: '(sourceId=notNull="true";tmsId=isNull="true";(roviProgramId=isNull="true",roviProgramId==0))',
    noRoviNoTmsNoSourceId: 'tmsId=isNull="true";sourceId=isNull="true";(roviProgramId=isNull="true",roviProgramId==0)',
    shellsExtrasShow: '(amsFranchise.extra=="true",amsEpisode.extra=="true")',
    shellsExtrasHide: '(amsFranchise.extra!="true";amsEpisode.extra!="true")',
    shellsExtrasIgnore:
        '(amsFranchise.extra=notNull="true",amsEpisode.extra=notNull="true",amsFranchise.extra=isNull="true",amsEpisode.extra=isNull="true")',
    unexpiredOnlyFields: ['unexpiredOnly'],
};

export default rsqlConfig;
